import { render, staticRenderFns } from "./ModalLots.vue?vue&type=template&id=f4d5aa0c&scoped=true&lang=pug&"
import script from "./ModalLots.vue?vue&type=script&lang=js&"
export * from "./ModalLots.vue?vue&type=script&lang=js&"
import style0 from "./ModalLots.vue?vue&type=style&index=0&id=f4d5aa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d5aa0c",
  null
  
)

export default component.exports